import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TransformCapitalizeFirstPipe } from './pipe.capitalize.first.letter';

/**
 * The TransformAgoModule module
 *
 * import { TransformAgoModule } from 'styleguide/src/shared/pipe/capitalizeFirstLetter/pipe.capitalize.first.letter.module';
 */
@NgModule({
    declarations: [
        TransformCapitalizeFirstPipe
    ],
    imports: [
        CommonModule
    ],
    exports: [
        TransformCapitalizeFirstPipe
    ]
})

// tslint:disable-next-line:no-unnecessary-class
export class TransformCapitalizeFirstModule {}
